import undefinity from "../../common/helpers/undefinity";
import Comment from "../../api/types/Comment";

export default function normalizeComment(comment: Comment) {
    return {
        comments: {
            [comment.id]: undefinity({...comment})
        }
    }
}